export default __webpack_public_path__ + "76088c9a3c0441bd34629acae6b5a459.png";